
import { validationMixin } from 'vuelidate'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  mixins: [validationMixin]
})
export default class CreateConfirmationDialogComponent extends Vue {
  code = ''
  message = ''
  sub = ''

  createDialog() {
    this.$store.dispatch('showConfirmationDialog', {
      Callback: this.confirmDialog,
      Code: this.code,
      Message: this.message,
      Sub: this.sub,
    })
  }

  confirmDialog() {
    alert('Callback executed correctly, closing dialog.')
    this.$store.dispatch('hideConfirmationDialog')
  }
}
